export default{

  setFetching({commit}, payload){
    commit('setFetchingForView',payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/knowledgechecks/actions.js